import Qc2ConfigMatchPage from './Qc2ConfigMatchPage';

export default function VendorReturnConfigMatchPage() {
  return <Qc2ConfigMatchPage captureKind="vendor-return" />;
}
